module.exports = {"TXTMOB_Exclusive":{"id":"TXTMOB_Exclusive","defaultMessage":"Exclusif","flags":["TRACK"],"track":"Exclusive"}}